<template>
  <div class="artwork-card" @click="goToDetail()">
    <img class="artwork-image" :src="imageUrl" />
    <div class="attr-row">
      <div class="id">
        ID: <span>{{ nftId }}</span>
      </div>
      <div class="artwork-name">
        {{ nftName }}
      </div>
    </div>
    <div class="button-wrapper">
      <SecondaryButton @onClick="goToDetail"> Detail </SecondaryButton>
      <!--      <SecondaryButton>-->
      <!--        Edit-->
      <!--      </SecondaryButton>-->
      <!--      <SecondaryButton>-->
      <!--        Delete-->
      <!--      </SecondaryButton>-->
    </div>
  </div>
</template>

<script>
import SecondaryButton from '@/components/BaseComponents/SecondaryButton.vue';

export default {
  components: { SecondaryButton },
  props: {
    imageUrl: {
      type: String,
      require: true,
      default: ''
    },
    nftContract: {
      type: String,
      require: true,
      default: ''
    },
    nftId: {
      type: [String, Number],
      require: true,
      default: ''
    },
    nftName: {
      type: String,
      require: true,
      default: ''
    }
  },
  methods: {
    goToDetail() {
      this.$router.push({
        name: 'asset-detail',
        params: {
          nftContract: this.nftContract,
          nftId: this.nftId
        }
      });
    },
    goToListing() {
      this.$router.push({
        name: 'listing',
        params: {
          nftContract: this.nftContract,
          nftId: this.nftId
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.artwork-card {
  min-width: 270px;
  width: 270px;
  height: 418px;
  background: #ffffff;
  border: 1px solid #f3f5fa;
  box-sizing: border-box;
  border-radius: 10px;
  padding: 12px 14px 0px;
  font-family: Inter;
  font-size: 14px;
  margin: 0 16px;
  color: #203a54;
  font-feature-settings: 'salt' on, 'liga' off;
  &:hover {
    box-shadow: rgb(0 0 0 / 10%) 0px 0px 20px;
    opacity: 0.95;
    // box-shadow: 0px 0px 4px #c8ecfb, 0px 0px 8px #127ef1, 0px 0px 12px #1166cf,
    //   0px 0px 16px #1255b1, 0px 0px 20px #114392, inset 0px 0px 4px #c8ecfb;
    // transform: scale(1.01);
  }
  .artwork-image {
    width: 242px;
    height: 300px;
    border-radius: 10px;
    &:hover {
      cursor: pointer;
    }
  }
  .attr-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .artwork-name,
    .id {
      margin-top: 12px;
      font-size: 16px;
      font-weight: bold;
    }
  }

  .button-wrapper {
    margin-top: 12px;
    display: flex;
    justify-content: space-between;
    div {
      width: 100%;
    }
  }
}
</style>
